export const BANNERS_LIST_KEY = 'BANNERS_LIST';
export const BANNERS_ONE_KEY = 'BANNERS_ONE_KEY';

export const REGION_LIST_KEY = 'REGION_LIST';
